import React, { memo } from "react";
import OutrosDetalheTable from "./OutrosDetalheTable";
const Outros = memo(props => {
  const {
    detalhe
  } = props;
  return <OutrosDetalheTable detalhe={detalhe} />;
});
Outros.displayName = "Outros";
export default Outros;
